import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import EventTransport from '../components/EventTransport';
import MediaSection from '../components/MediaSection';
import Commitments from '../components/Commitments';
import Fleet from '../components/Fleet';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import { AnimateOnScroll } from '../hooks/useScrollAnimation';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <AnimateOnScroll>
          <ServicesSection />
        </AnimateOnScroll>
        <AnimateOnScroll animation="animate-slide-left">
          <EventTransport />
        </AnimateOnScroll>
        <AnimateOnScroll>
          <MediaSection />
        </AnimateOnScroll>
        <AnimateOnScroll animation="animate-slide-right">
          <Commitments />
        </AnimateOnScroll>
        <AnimateOnScroll animation="animate-scale">
          <Fleet />
        </AnimateOnScroll>
        <AnimateOnScroll>
          <CTASection />
        </AnimateOnScroll>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
